import styled from 'styled-components';

export const CompanyName = styled.h1`
  font-weight: bold;
  margin: 10px 0 5px 0;
  color: #444444;
`;
